import { classSet } from '@umu/umu-dom';
import './index.scss';
import React, { useCallback, useRef } from 'react';

interface IProps {
    show: boolean;
    children: JSX.Element | JSX.Element[];
    className?: string;
}

export const TransitionShow = (props: IProps) => {
    const { className = '', show } = props;
    const contentHeight = useRef(0);
    const shown = useRef(false);
    const wrapRef = useRef<HTMLDivElement | null>(null);
    const contentRef = useCallback((node: HTMLDivElement | null) => {
        if (node && node.offsetHeight) {
            contentHeight.current = node.offsetHeight;
            wrapRef.current = node.parentElement as HTMLDivElement;
            show && (shown.current = true);
        }
    }, [show]);

    const cls = classSet({
        [className]: true,
        'transition-show-wrap': true,
        fold: !show,
        unfold: show,
        shown: shown.current,
    });

    return (
        <div className={cls}>
            <div ref={contentRef}>
                {props.children}
            </div>
        </div>
    );
};
